const type = 'SET_CARD_EDIT_PARAM_OUTCOME';

const setCardEditParamOutcome = (data) => ({
  data,
  type,
});

export { type };
export default setCardEditParamOutcome;
